import { Controller } from '@hotwired/stimulus'
import { useClickOutside } from 'stimulus-use'
import { get } from '@rails/request.js'
import { leave, toggle } from 'el-transition'

export default class extends Controller {
  static targets = ['clear', 'form', 'resultsContainer', 'term']

  initialize() {
    this.hiddenClass = 'hidden'
    this.timer = 0
  }

  connect() {
    useClickOutside(this)
  }

  clear() {
    this.termTarget.value = ''
    this.#hide(this.clearTarget)
    leave(this.resultsContainerTarget)
  }

  clickOutside(event) {
    this.clear(event)
  }

  filter(event) {
    clearTimeout(this.timer)
    this.#show(this.clearTarget)

    this.timer = setTimeout(
      () => this.#fetchResults(event),
      350,
    )
  }

  async #fetchResults(event) {
    if (event.target.value === '') {
      this.#hide(this.clearTarget)
      toggle(this.resultsContainerTarget)
    } else {
      const response = await get(
        this.formTarget.action,
        {
          query: { term: event.target.value },
          responseKind: 'json',
        },
      )

      if (response.ok) {
        const data = await response.json
        this.resultsContainerTarget.innerHTML = data.results

        if (this.resultsContainerTarget.classList.contains(this.hiddenClass)) {
          toggle(this.resultsContainerTarget)
        }
      }
    }
  }

  #hide(...elements) {
    elements.forEach((element) => {
      element.classList.add(this.hiddenClass)
    })
  }

  #show(...elements) {
    elements.forEach((element) => {
      element.classList.remove(this.hiddenClass)
    })
  }
}
